// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../fe-workerportal/node_modules/css-loader/dist/cjs.js??ref--9-oneOf-3-1!../../../../fe-workerportal/node_modules/postcss-loader/src/index.js??ref--9-oneOf-3-2!../../../../fe-workerportal/node_modules/postcss-loader/src/index.js??ref--9-oneOf-3-3!../../../../fe-workerportal/node_modules/sass-loader/dist/cjs.js??ref--9-oneOf-3-4!./base.scss");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../fe-workerportal/node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("74fc2149", content, true, {"sourceMap":false,"shadowMode":false});